// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.MobMenu_container__Iiz\\+B {
  display: none;
}

@media (max-width: 1100px) {
  .MobMenu_container__Iiz\\+B {
    display: block;
    position: absolute;
    top: 100%;
    left: 0;
    width: 100%;
    border-bottom: 1px solid rgba(255, 255, 255, 0.15);
    border-top: 1px solid rgba(255, 255, 255, 0.15);
    padding-top: 15px;
    padding-bottom: 15px;
    background-color: #171716;
  }
  .MobMenu_container__Iiz\\+B .MobMenu_content__dtLao {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 85%;
    margin: 0 auto;
  }
  .MobMenu_container__Iiz\\+B .MobMenu_content__dtLao .MobMenu_title__1DoxJ {
    display: flex;
    align-items: center;
    gap: 8px;
    font-size: 14px;
    font-weight: 600;
    color: rgba(255, 255, 255, 0.4509803922);
  }
  .MobMenu_container__Iiz\\+B .MobMenu_content__dtLao .MobMenu_title__1DoxJ .MobMenu_current__qmSix {
    color: #FAF9F8;
  }
  .MobMenu_container__Iiz\\+B .MobMenu_content__dtLao .MobMenu_arrow__frmWV {
    transform: rotate(270deg);
  }
  .MobMenu_container__Iiz\\+B .MobMenu_menu__kwJhn {
    position: absolute;
    top: 100%;
    left: 0;
    right: 0;
    background-color: #171716;
  }
  .MobMenu_container__Iiz\\+B .MobMenu_menu__kwJhn .MobMenu_menuContent__zZ7jH .MobMenu_menuItem__gCcCZ {
    border-bottom: 1px solid rgba(255, 255, 255, 0.15);
    border-top: 1px solid rgba(255, 255, 255, 0.15);
    padding-top: 20px;
    padding-bottom: 20px;
    color: #C2BDB2;
    font-size: 14px;
    font-weight: 600;
  }
  .MobMenu_container__Iiz\\+B .MobMenu_menu__kwJhn .MobMenu_menuContent__zZ7jH .MobMenu_menuItem__gCcCZ .MobMenu_menuItemContent__V7GpO {
    width: 85%;
    margin: 0 auto;
  }
  .MobMenu_container__Iiz\\+B .MobMenu_menu__kwJhn .MobMenu_menuContent__zZ7jH .MobMenu_menuItem__gCcCZ .MobMenu_menuItemContent__V7GpO.MobMenu_active__6rGhf {
    color: #F2F740;
  }
  .MobMenu_container__Iiz\\+B.MobMenu_active__6rGhf {
    background-color: rgba(255, 255, 255, 0.1490196078);
  }
}`, "",{"version":3,"sources":["webpack://./src/shared/components/header/MobMenu/MobMenu.module.scss"],"names":[],"mappings":"AAEA;EACE,aAAA;AADF;;AAIA;EACE;IACE,cAAA;IACA,kBAAA;IACA,SAAA;IACA,OAAA;IACA,WAAA;IACA,kDAAA;IACA,+CAAA;IACA,iBAAA;IACA,oBAAA;IACA,yBAAA;EADF;EAGE;IACE,aAAA;IACA,8BAAA;IACA,mBAAA;IACA,UAAA;IACA,cAAA;EADJ;EAGI;IACE,aAAA;IACA,mBAAA;IACA,QAAA;IACA,eAAA;IACA,gBAAA;IACA,wCAAA;EADN;EAGM;IACE,cAAA;EADR;EAKI;IACE,yBAAA;EAHN;EAOE;IACE,kBAAA;IACA,SAAA;IACA,OAAA;IACA,QAAA;IACA,yBAAA;EALJ;EASM;IACE,kDAAA;IACA,+CAAA;IACA,iBAAA;IACA,oBAAA;IACA,cAAA;IACA,eAAA;IACA,gBAAA;EAPR;EASQ;IACE,UAAA;IACA,cAAA;EAPV;EASU;IACE,cAAA;EAPZ;EAcE;IACE,mDAAA;EAZJ;AACF","sourcesContent":["@use 'assets/styles/global.scss' as *;\n\n.container {\n  display: none;\n}\n\n@media (max-width: 1100px) {\n  .container {\n    display: block;\n    position: absolute;\n    top: 100%;\n    left: 0;\n    width: 100%;\n    border-bottom: 1px solid rgba(255, 255, 255, 0.15);\n    border-top: 1px solid rgba(255, 255, 255, 0.15);\n    padding-top: 15px;\n    padding-bottom: 15px;\n    background-color: #171716;\n\n    .content {\n      display: flex;\n      justify-content: space-between;\n      align-items: center;\n      width: 85%;\n      margin: 0 auto;\n\n      .title {\n        display: flex;\n        align-items: center;\n        gap: 8px;\n        font-size: 14px;\n        font-weight: 600;\n        color: #FFFFFF73;\n\n        .current {\n          color: #FAF9F8;\n        }\n      }\n\n      .arrow {\n        transform: rotate(270deg);\n      }\n    }\n\n    .menu {\n      position: absolute;\n      top: 100%;\n      left: 0;\n      right: 0;\n      background-color: #171716;\n\n      .menuContent {\n\n        .menuItem {\n          border-bottom: 1px solid rgba(255, 255, 255, 0.15);\n          border-top: 1px solid rgba(255, 255, 255, 0.15);\n          padding-top: 20px;\n          padding-bottom: 20px;\n          color: #C2BDB2;\n          font-size: 14px;\n          font-weight: 600;\n\n          .menuItemContent {\n            width: 85%;\n            margin: 0 auto;\n\n            &.active {\n              color: #F2F740;\n            }\n          }\n        }\n      }\n    }\n\n    &.active {\n      background-color: #FFFFFF26;\n    }\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `MobMenu_container__Iiz+B`,
	"content": `MobMenu_content__dtLao`,
	"title": `MobMenu_title__1DoxJ`,
	"current": `MobMenu_current__qmSix`,
	"arrow": `MobMenu_arrow__frmWV`,
	"menu": `MobMenu_menu__kwJhn`,
	"menuContent": `MobMenu_menuContent__zZ7jH`,
	"menuItem": `MobMenu_menuItem__gCcCZ`,
	"menuItemContent": `MobMenu_menuItemContent__V7GpO`,
	"active": `MobMenu_active__6rGhf`
};
export default ___CSS_LOADER_EXPORT___;
